<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/leave/applications">{{ $t('leave_app') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('new') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onSave"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.EmployeeId.$error }">
                                <label class="label-control blue">{{$t('employee_name')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="$v.model.EmployeeId.$model" @change="empChange">
                                        <option v-for="ret in employees" :value="ret.Id" :key="ret.Id">{{ret.Num}} : {{ret.KhmerName}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-1">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.LeaveSchemeId.$error }">
                                <label class="label-control blue">&nbsp;</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="model.LeaveSchemeName" readonly>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="model.SubmittedDate" @change="onDateChange" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('type')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="model.ApplyType" @change="typeChange">
                                        <option value="Day">Day</option>
                                        <option value="Haft Day Morning">Haft Day Morning</option>
                                        <option value="Haft Day Afternoon">Haft Day Afternoon</option>
                                        <option value="Hour">Hour</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('from_date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="model.FromDate">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('to_date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="model.ToDate">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.LeaveTypeId.$error }">
                                <label class="label-control blue">{{$t('leave_category')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="$v.model.LeaveTypeId.$model">
                                        <option v-for="ret in leaveTypes" :key="ret.Id" :value="ret.Id">{{ret.Code}} : {{ret.Description}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-1">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('qty_day')}}</label>
                                <div>
                                    <input type="number" class="form-control form-control-sm" v-model="model.TakenDays" :disabled="model.ApplyType!='Day'" @change="onDayChange" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-1">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('qty_hour')}}</label>
                                <div>
                                    <input type="number" class="form-control form-control-sm" v-model="model.TakenHours" :disabled="model.ApplyType!='Hour'">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Reason.$error }">
                                <label class="control-label blue">{{$t('reason')}}</label>
                                <div>
                                    <textarea class="form-control form-control-sm" v-model="$v.model.Reason.$model"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'
    export default {
        data() {
            return {
                model: {
                    EmployeeId: '',
                    SubmittedDate: this.$now().format('YYYY-MM-DD'),
                    ApplyType: 'Day',
                    TakenDays: 1,
                    TakenHours: 8,
                    FromDate: this.$now().format('YYYY-MM-DD'),
                    ToDate: this.$now().format('YYYY-MM-DD'),
                    LeaveTypeId: '',
                    LeaveSchemeId: '',
                    LeaveSchemeName: '',
                    Reason: ''
                },
                employees: [],
                leaveTypes: []
            }
        },
        validations: {
            model: {
                EmployeeId: { required },
                LeaveSchemeId: { required },
                LeaveTypeId: { required },
                Reason: { required }
            }
        },
        created() {
            var id = this.$route.params.id;
            if (id != undefined && id != null && id != '') {
                this.findById(id);
            }
        },
        mounted() {
            this.employeeList();
        },
        methods: {
            findById(id) {
                var loading = this.$loading.show();
                this.$api().post('leave/application/find', { Id: id }).then(res => {
                    if (this.$isValid(res)) {
                        this.model = res.data.Json.Application;
                        this.model.SubmittedDate = this.$format(this.model.SubmittedDate, 'YYYY-MM-DD');
                        this.model.FromDate = this.$format(this.model.FromDate, 'YYYY-MM-DD');
                        this.model.ToDate = this.$format(this.model.ToDate, 'YYYY-MM-DD');
                        this.model.LeaveSchemeId = res.data.Json.Scheme.Id;
                        this.model.LeaveSchemeName = res.data.Json.Scheme.Code;
                        this.leaveTypes = res.data.Json.LeaveTypes;
                    }
                }).finally(function () { loading.hide(); });
            },
            employeeList() {
                var loading = this.$loading.show();
                this.$api().post('employees', { CompanyId: this.$store.state.company.Id }).then(res => {
                    if (this.$isValid(res)) {
                        this.employees = res.data.Data;
                    }
                }).finally(function () { loading.hide(); });
            },
            empChange() {
                var loading = this.$loading.show();
                this.$api().post('employee/leave', { Id: this.model.EmployeeId }).then(res => {
                    if (this.$isValid(res)) {
                        this.model.LeaveSchemeId = res.data.Json.Scheme.Id;
                        this.model.LeaveSchemeName = res.data.Json.Scheme.Code;
                        this.leaveTypes = res.data.Json.LeaveTypes;
                    }
                }).finally(function () { loading.hide(); });
            },
            typeChange() {
                var apt = this.model.ApplyType;
                if (apt == 'Day') {
                    this.model.TakenDays = 1;
                    this.model.TakenHours = 8;
                } else if (apt == 'Haft Day Morning' || apt == 'Haft Day Afternoon') {
                    this.model.TakenDays = 0.5;
                    this.model.TakenHours = 4;
                } else if (apt == 'Hour') {
                    this.model.TakenDays = 0;
                    this.model.TakenHours = 1;
                }
            },
            onSave() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.model.CompanyId = this.$store.state.company.Id;
                    this.model.ClientId = this.$store.state.company.ClientId;

                    var loading = this.$loading.show();
                    this.$api().post('leave/application/save', this.model).then(res => {
                        if (this.$isValid(res)) {
                            this.$router.go(-1)
                        }
                    }).finally(function () { loading.hide(); });
                }
            },
            onDateChange() {
                this.model.FromDate = this.$format(this.model.SubmittedDate, 'YYYY-MM-DD');
                this.model.ToDate = this.$format(this.model.SubmittedDate, 'YYYY-MM-DD');
            },
            onDayChange() {
                this.model.TakenHours = this.model.TakenDays * 8;
            }
        }
    }
</script>
